// extracted by mini-css-extract-plugin
export default {"categoryname":"ProductsModalCreate_categoryname__POjiV","deletebutton":"ProductsModalCreate_deletebutton__HzHjL"};